import { ref, h } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d5d88b96"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "export-content"
};
const _hoisted_2 = {
  class: "download-content"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "1.", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "点击使用模板", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "desc"
}, "仅支持消耗型＆非消耗型商品导入", -1));
const _hoisted_6 = {
  class: "upload-content"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "2.", -1));
const _hoisted_8 = {
  class: "content-wrap"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "name2"
}, [/*#__PURE__*/_createTextVNode(" 拖拽文件到此处，或 "), /*#__PURE__*/_createElementVNode("span", null, "点击上传")], -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "desc"
}, "如文件被加密，请解密后上传，仅支持excel文件", -1));
import { awaitWrap, OK } from '@/common';
import { importGoods } from '@/api/goodsSetting';
import { message, Modal } from 'ant-design-vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'GoodExportModal',
  props: {
    modalVisible: {
      type: Boolean
    },
    dbtId: null,
    prodChnl: null
  },
  emits: ['update:modalVisible', 'updateList'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const fileList = ref([]);
    // 按照平台类型分组管理URL
    const urlObj = {
      // 独立平台
      google: 'https://ewe8txd9jt.feishu.cn/wiki/P0VzwW9yeiLRIakC6d1cuiwmnle',
      apple: 'https://ewe8txd9jt.feishu.cn/wiki/YfmdwnFM1i6mlSkSDRActmYtnif',
      google_amazon: 'https://ewe8txd9jt.feishu.cn/wiki/OgmLwc8U8iG94XkD3ifcHuchnGe',
      // 头条、小米、OPPO、vivo、华为系列使用同一模板
      xiaomi: 'https://ewe8txd9jt.feishu.cn/wiki/Yz1jwfyIWi9ig1kaYsecQ3ICnee?from=from_copylink',
      oppo: 'https://ewe8txd9jt.feishu.cn/wiki/Yz1jwfyIWi9ig1kaYsecQ3ICnee?from=from_copylink',
      vivo: 'https://ewe8txd9jt.feishu.cn/wiki/Yz1jwfyIWi9ig1kaYsecQ3ICnee?from=from_copylink',
      huawei: 'https://ewe8txd9jt.feishu.cn/wiki/Yz1jwfyIWi9ig1kaYsecQ3ICnee?from=from_copylink',
      huawei_foreign: 'https://ewe8txd9jt.feishu.cn/wiki/Yz1jwfyIWi9ig1kaYsecQ3ICnee?from=from_copylink',
      huawei_runtime_fastgame: 'https://ewe8txd9jt.feishu.cn/wiki/Yz1jwfyIWi9ig1kaYsecQ3ICnee?from=from_copylink',
      harmony: 'https://ewe8txd9jt.feishu.cn/wiki/Yz1jwfyIWi9ig1kaYsecQ3ICnee?from=from_copylink',
      BanHao: 'https://ewe8txd9jt.feishu.cn/wiki/Yz1jwfyIWi9ig1kaYsecQ3ICnee?from=from_copylink',
      // 微信、抖音等小游戏平台使用同一模板
      weixin: 'https://ewe8txd9jt.feishu.cn/wiki/OO1uw2DDMibxE7kdVKdcFZHInvd?from=from_copylink',
      zijie: 'https://ewe8txd9jt.feishu.cn/wiki/OO1uw2DDMibxE7kdVKdcFZHInvd?from=from_copylink',
      kuaishou: 'https://ewe8txd9jt.feishu.cn/wiki/OO1uw2DDMibxE7kdVKdcFZHInvd?from=from_copylink',
      alipay: 'https://ewe8txd9jt.feishu.cn/wiki/OO1uw2DDMibxE7kdVKdcFZHInvd?from=from_copylink'
    };
    // 特殊渠道映射表，将特殊渠道映射到标准渠道
    const specialChannelMap = {
      toutiao: 'xiaomi',
      tap: 'xiaomi'
    };
    const errorTableBase64 = ref('');
    const closeModal = () => {
      errorTableBase64.value = '';
      emits('update:modalVisible', false);
    }; // 关闭弹窗
    const useTemplate = () => {
      // 获取实际使用的渠道
      let actualChannel = props.prodChnl;
      // 检查是否为特殊渠道，如果是则使用映射的渠道
      Object.entries(specialChannelMap).forEach(([specialChannel, mappedChannel]) => {
        if (String(props.prodChnl).includes(specialChannel)) {
          actualChannel = mappedChannel;
        }
      });
      // 获取渠道对应的URL
      const templateUrl = urlObj[actualChannel] || urlObj.xiaomi; // 默认使用小米模板
      // 打开模板链接
      window.open(templateUrl, '_blank');
    }; // 使用模板
    const customRequest = async ({
      file
    }) => {
      const formData = new FormData();
      formData.append('type', '2');
      formData.append('file', file);
      formData.append('dbtId', props.dbtId);
      formData.append('prodChnl', props.prodChnl);
      const [err, res] = await awaitWrap(importGoods(formData));
      if (res) {
        if (res.code === OK) {
          message.success('导入成功');
          emits('updateList');
          closeModal();
        } else {
          if (res.code !== '500') {
            var _res$data;
            errorTableBase64.value = (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.errorBase64;
            Modal.confirm({
              title: '导入失败',
              centered: true,
              content: h('div', {}, [h('div', {}, '导入商品信息有误！'), h('div', {}, '请下载校验后的《商品信息列表》，更正标记字段后重新上传')]),
              okText: '下载',
              onOk: () => {
                var _res$data2;
                const downloadElement = document.createElement('a');
                downloadElement.download = '商品信息列表.xls';
                downloadElement.href = `data:;base64,${(_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.errorBase64}`; // base64字符串
                document.body.appendChild(downloadElement);
                downloadElement.click();
                document.body.removeChild(downloadElement);
              }
            });
          }
        }
      }
      if (err) {}
      fileList.value = [];
    }; // 上传文件
    // const downloadErrorTable = () => {
    //   try {
    //     const downloadElement = document.createElement('a')
    //     downloadElement.download = '商品信息列表.xls'
    //     downloadElement.href = `data:;base64,${errorTableBase64.value}` // base64字符串
    //     document.body.appendChild(downloadElement)
    //     downloadElement.click()
    //     document.body.removeChild(downloadElement)
    //   } catch (err) {
    //     message.error('下载失败')
    //   }
    // } // 下载错误表格
    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_upload_dragger = _resolveComponent("a-upload-dragger");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        open: __props.modalVisible,
        title: "文件导入",
        width: "788px",
        onCancel: closeModal,
        centered: "",
        footer: false
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", {
          class: "content-wrap",
          onClick: useTemplate
        }, [_createVNode(_component_svg_icon, {
          "icon-class": "download_stencil",
          "class-name": "download-icon"
        }), _hoisted_4, _hoisted_5])]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createVNode(_component_a_upload_dragger, {
          class: "file-upload",
          fileList: fileList.value,
          "onUpdate:fileList": _cache[0] || (_cache[0] = $event => fileList.value = $event),
          name: "file",
          multiple: false,
          action: "",
          customRequest: customRequest
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createVNode(_component_svg_icon, {
            "icon-class": "upload_stencil",
            "class-name": "download-icon"
          }), _hoisted_9, _hoisted_10])]),
          _: 1
        }, 8, ["fileList"])])])]),
        _: 1
      }, 8, ["open"]);
    };
  }
});